'use client'

import React, { useState, useRef, useEffect } from 'react'
import styles from './quick-link2.module.scss'
import QuickLinkWrapper from './quick-link-wrapper'

type QuickLinksProps = {
  quickLinkLabels?: string[]
  quickLinkSectionIds?: string[]
  segmentEventCommonProperties: any
}

const QuickLinks = ({
  quickLinkLabels = [],
  quickLinkSectionIds = [],
  segmentEventCommonProperties,
}: QuickLinksProps) => {
  const [isSticky, setIsSticky] = useState(false)
  const [windowWidth, setWindowWidth] = useState(0)
  const quickLinksSectionRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div
      id="quickLinksSection"
      ref={quickLinksSectionRef}
      className={`${styles.container} ${isSticky ? styles.isSticky : styles.isNotSticky}`}>
      <QuickLinkWrapper
        quickLinkLabels={quickLinkLabels}
        quickLinkSectionIds={quickLinkSectionIds}
        updateIsSticky={setIsSticky}
        quickLinksRef={quickLinksSectionRef}
        segmentEventCommonProperties={segmentEventCommonProperties}
        windowWidth={windowWidth}
      />
    </div>
  )
}

export default QuickLinks
